import React from "react";
import classNames from "classnames";
import styles from "./ModalDialogBox.module.scss";
import Icon from '../images/Icon';

interface ModalDialogBoxProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode; // Contenu à afficher dans la boîte de dialogue
}

export const ModalDialogBox: React.FC<ModalDialogBoxProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  if (!isOpen) return null; // Si le modal est fermé, on ne rend rien

  return (
    <>
      {/* Overlay */}
      <div
        className={classNames(styles.overlay)}
      ></div>

      {/* Modal Box */}
      <div className={classNames(styles.modal)}>
	    <div className={classNames(styles.wrapper)}>
	  
	  {/* Bouton de fermeture */}
      {onClose && (
        <div className={styles.window_close_button}>
          <Icon
            name="cross"
            onClick={onClose}
            color="var(--color-Icon-FG)"
            hoverColor="var(--color-Icon-hover-FG)"
            width={12}
            height={12}
          />
        </div>
      )}
	  
        {children}
        </div>
      </div>
    </>
  );
};

export default ModalDialogBox;
